import { render, staticRenderFns } from "./DeliveryCalculate.vue?vue&type=template&id=4bff140b&scoped=true&"
import script from "./DeliveryCalculate.vue?vue&type=script&lang=js&"
export * from "./DeliveryCalculate.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryCalculate.vue?vue&type=style&index=0&id=4bff140b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bff140b",
  null
  
)

export default component.exports